"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = Serializer;

function Serializer(obj, prefix) {
  var str = [];
  Object.keys(obj).forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      var prefixedKey = prefix ? prefix + "[" + key + "]" : key;
      var value = obj[key];
      var serialized = (typeof value === "undefined" ? "undefined" : _typeof(value)) == "object" ? Serializer(value, prefixedKey) : encodeURIComponent(prefixedKey) + "=" + encodeURIComponent(value);
      str.push(serialized);
    }
  });
  return str.join("&");
}